import React, { useContext } from 'react';

import { AudienceModalState } from  '@/interfaces/ContentAudienceModal';

import BasicButton from '../global/buttons/BasicButton/BasicButton';
import {ContentAudienceContext} from './ContentAudienceContext';

import ViewParents from '../viewParents/ViewParents';

const ContentAudienceViewParents = ({setAudienceModalState, back}: {setAudienceModalState: (a: AudienceModalState) =>  void, back: AudienceModalState}) => {
    
    const {contentTitle, contentId} = useContext(ContentAudienceContext)
    
    return (
    <section>
        <h2 className="reset-audience-header">{contentTitle} - Parent Items</h2>
        
        <div className="reset-audience-content-wrapper">
            <ViewParents contentId={contentId} modalSelector='.ViewParents'/>
        </div>

        <div className="audience-modal-control-wrapper">
            <BasicButton className="back-button" content={'Back'} ariaLabel={'Back'} onButtonClick={() => setAudienceModalState(back)}/>
        </div>
    </section>)
}

export default ContentAudienceViewParents;